export default __webpack_public_path__ + "static/media/avon-material.406cbe98.png";